import { capitalize } from 'filters/text';

const avatarColorsCompass = ['random-green', 'random-pink', 'random-yellow'];

// User-like objects come from APIs where names are nullable and key casing varies;
// user itself can be undefined (e.g. a mention of a staff deleted from the account)
const getFirstName = (user) => user?.first_name ?? user?.firstName ?? user?.firstname ?? '';
const getLastName = (user) => user?.last_name ?? user?.lastName ?? user?.lastname ?? '';
const getFullName = (user) => user?.name ?? user?.full_name ?? user?.fullName ?? null;

const randomAvatarColorFullname = (fullname) => {
    const fullNameLength = fullname ? fullname.replace(/\s/g, '').length : 0;
    const color = avatarColorsCompass[fullNameLength % avatarColorsCompass.length];
    return `colors-component-background-avatar-${color}`;
};

const getUserInitials = (user) => {
    return `${getFirstName(user).charAt(0)}${getLastName(user).charAt(0)}`;
};

const getFullNameUser = (user, capitalized = false) => {
    if (getFullName(user)) {
        return capitalize(getFullName(user)) ?? getFullName(user);
    }

    const firstName = capitalized ? capitalize(getFirstName(user)) : getFirstName(user);
    const lastName = capitalized ? capitalize(getLastName(user)) : getLastName(user);
    return firstName.concat(' ', lastName).trim();
};

const getAvatarColor = (user) => {
    return randomAvatarColorFullname(getFullNameUser(user));
};

const formatUserToCompassAvatar = (user) => {
    return {
        initials: getUserInitials(user).toUpperCase(),
        colorType: getAvatarColor(user),
        photo: user?.avatar ?? '',
    };
};

export {
    randomAvatarColorFullname,
    getUserInitials,
    getFullNameUser,
    getAvatarColor,
    formatUserToCompassAvatar,
};
